import { render, staticRenderFns } from "./EndorsementContractPayment.vue?vue&type=template&id=a16d5ffa"
import script from "./EndorsementContractPayment.vue?vue&type=script&lang=js"
export * from "./EndorsementContractPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports